import { useEffect, useState } from 'react';
import api from '../../../../../api';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutSection= () => {
    const [aboutSection, setAboutSection] = useState([]);
 const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

      useEffect(() => {
          if (typeof window !== 'undefined') {
              const AOS = require('aos');
              AOS.init({
                  duration: 1000,
                  once: true
              });
          }
      }, []);

      
  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        const response = await api.get('/api/pages/center');
        const groupData = response.data.groups;
        const about_section = groupData[1].about_section;

        setAboutSection(about_section);
       
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCarouselData();
  }, []);



  return (
    <section className="mb-3 mb-md-5 ">
      <div className="container">
        <div className="row ">
          {/* Optional heading removed in original */}
          <h2
            className="sec-title text-center"
            data-aos="fade-up"></h2>
        </div>

        <div className="row" data-aos="fade-up" data-aos-duration="1000">
          <p style={{ textAlign: 'justify' }} >
            {aboutSection.about_content}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;